import { APP_ENV } from '@common/config/api';
import { getEnvVar } from '@common/utils/env';
import axios, { AxiosRequestConfig } from 'axios';

// Helper function to get CSRF token from cookies
function getCsrfToken(): string | null {
  const name = 'csrftoken';
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
}

console.log('APP_ENV', APP_ENV);

export const axiosInstance = axios.create({
  baseURL: APP_ENV === 'local' ? '/api' : getEnvVar('VITE_API'),
  headers: { 'Content-Type': 'application/json' }
});

// Add request interceptor to handle CSRF token for mutating requests
axiosInstance.interceptors.request.use((config: AxiosRequestConfig) => {
  // Only set CSRF token for mutating requests when using session auth
  if (['post', 'put', 'patch', 'delete'].includes(config.method?.toLowerCase() || '')) {
    const csrfToken = getCsrfToken();
    if (csrfToken && config.headers) {
      config.headers['X-CSRFToken'] = csrfToken;
    }
  }
  return config;
});

export function setAuthToken(token: string | null, isJwt?: boolean, sessionToken?: string) {
  if (token) {
    axiosInstance.defaults.withCredentials = false;
    if (isJwt) {
      axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${token}`;
    } else {
      axiosInstance.defaults.headers.common['Authorization'] = `Token ${token}`;
    }
  } else {
    // When clearing token, switch to session-based auth
    axiosInstance.defaults.withCredentials = true;
    if (sessionToken) {
      axiosInstance.defaults.headers.common['X-Hotel-Session'] = sessionToken;
    }
    delete axiosInstance.defaults.headers.common['Authorization'];
  }
}
